import React from "react";
import Button from "components/button";
import { connect } from "react-redux";
import { LuArrowLeft } from "react-icons/lu";
import { useNavigate } from "react-router-dom";

function AccessButton(props) {
    const {
        label,
        backLabel,
        baseRoute,
        recordId,
        iconStart,
        iconEnd,
        mode = "view",
        withBack = false,
        backUrl,
        btnClass = "btn-emerald",
        state,
        to,
        ...rest 
    } = props;

    const navigate = useNavigate();

    const handleBack = () => {
        navigate(backUrl ?? baseRoute);
    };

    const handleView = () => {
        if (baseRoute && recordId) {
            navigate(`${baseRoute}/${recordId}/view`, { state });
        }
    };

    const handleClick = () => {
        if (to) {
            navigate(to, { state });
        } else {
            handleView();
        }
    };

    return (
        <div className="" {...rest}>
            {mode === "view" && (
                <div className="flex items-center">
                    {withBack && (
                        <Button
                            type="button"
                            className="access-button btn-back"
                            onClick={handleBack}
                        >   
                            <LuArrowLeft className="w-4 h-4" />
                            {backLabel && (
                                <span className="text-base font-medium">{backLabel}</span>
                            )}
                        </Button>
                    )}

                    {label && (
                        <Button
                            type="button"
                            className={`access-button w-full ${btnClass}`}
                            onClick={handleClick}
                        >
                            {iconStart && (
                                <span className="flex items-center justify-center mr-2">
                                    {React.cloneElement(iconStart, {
                                        className:
                                            iconStart.props.className ?? "w-4 h-4",
                                    })}
                                </span>
                            )}

                            <span>{label}</span>

                            {iconEnd && (
                                <span className="flex items-center justify-center ml-2">
                                    {React.cloneElement(iconEnd, {
                                        className:
                                            iconEnd.props.className ?? "w-4 h-4",
                                    })}
                                </span>
                            )}
                        </Button>
                    )}
                </div>
            )}
        </div>
    );
};

const mapStateToProps = () => ({});
const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(AccessButton);
